/**
 * Polish profanity data
 * Auto-generated from JSON files - DO NOT EDIT MANUALLY
 *
 * Language: Polish
 * Version: 1.0.0
 * Last Updated: 2025-09-30
 * Total Entries: 204
 */

export const PL = {
  "metadata": {
    "name": "Polish",
    "code": "pl",
    "version": "1.0.0",
    "lastUpdated": "2025-09-30",
    "wordCount": 204
  },
  "words": [
    {
      "word": "alfons",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Prostitution",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "bałwan",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Intelligence Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "barany",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Intelligence Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "brzydal",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "brzydula",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "burak",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "burdel",
      "severity": 2,
      "categories": [
        "sexual",
        "profanity",
        "chaos"
      ],
      "variations": [
        "burdelu",
        "burdelowi",
        "burdelem",
        "burdele",
        "burdeli",
        "burdelów",
        "b*rdel"
      ],
      "case_sensitive": false,
      "context_notes": "Brothel/mess - moderate profanity, used to describe chaos or disorder",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - descriptive usage"
    },
    {
      "word": "bzykać",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Copulation Verbs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "cham",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "chamstwo",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "cholera",
      "severity": 1,
      "categories": [
        "religious",
        "mild_profanity"
      ],
      "variations": [
        "cholerę",
        "cholery",
        "cholerze",
        "cholerą",
        "jasna cholera",
        "cholerni",
        "cholerny",
        "cholernie"
      ],
      "case_sensitive": false,
      "context_notes": "Mild expletive - damn/bloody hell, religiously derived but not highly offensive",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - cholerny, cholernie"
    },
    {
      "word": "cholernie",
      "severity": 1,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Religious",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "cholerny",
      "severity": 1,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Religious",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "chuj",
      "severity": 3,
      "categories": [
        "sexual",
        "profanity",
        "anatomy"
      ],
      "variations": [
        "chuja",
        "chujem",
        "chujowi",
        "chuje",
        "chujów",
        "chujem",
        "chujami",
        "chujach",
        "ch*j",
        "chujoń"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for male genitalia (dick/cock), used as insult or to describe bad situations",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "High - chujnia, chujowy, etc."
    },
    {
      "word": "chujek",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Male Genitalia",
      "target_type": "male",
      "regions": [
        "all"
      ]
    },
    {
      "word": "chujem",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Male Genitalia",
      "target_type": "male",
      "regions": [
        "all"
      ]
    },
    {
      "word": "chujnia",
      "severity": 3,
      "categories": [
        "profanity",
        "noun",
        "situation"
      ],
      "variations": [
        "chujni",
        "chujnię",
        "chujnią",
        "chujnie",
        "chuj*ia"
      ],
      "case_sensitive": false,
      "context_notes": "Shitty situation - noun derived from chuj describing bad circumstances",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - situational description"
    },
    {
      "word": "chujowa",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of chuj",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "chujowe",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of chuj",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "chujowo",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of chuj",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "chujowy",
      "severity": 3,
      "categories": [
        "profanity",
        "adjective",
        "derogatory"
      ],
      "variations": [
        "chujowa",
        "chujowe",
        "chujowych",
        "chujowym",
        "chujowej",
        "chujowymi",
        "chuj*wy"
      ],
      "case_sensitive": false,
      "context_notes": "Shitty/fucking bad - adjective derived from chuj meaning very bad quality",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - descriptive adjective"
    },
    {
      "word": "chuju",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Male Genitalia",
      "target_type": "male",
      "regions": [
        "all"
      ]
    },
    {
      "word": "ciąć",
      "severity": 1,
      "categories": [
        "mild_profanity",
        "slang"
      ],
      "variations": [
        "ciął",
        "ciąłem",
        "ciąłeś",
        "ciąła",
        "ciąłaś",
        "ciąłyśmy",
        "ciąłem to"
      ],
      "case_sensitive": false,
      "context_notes": "To cut/fail - mild slang, used about failing at something",
      "target_type": "general",
      "regions": [
        "young"
      ],
      "compound_potential": "Low - slang usage"
    },
    {
      "word": "ciepły",
      "severity": 1,
      "categories": [
        "homophobic",
        "hate_speech",
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Homosexual Slurs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "ciot",
      "severity": 1,
      "categories": [
        "homophobic",
        "hate_speech",
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Homosexual Slurs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "ciota",
      "severity": 3,
      "categories": [
        "homophobic",
        "hate_speech",
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Homosexual Slurs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "cipa",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomy",
        "profanity"
      ],
      "variations": [
        "cipę",
        "cipy",
        "cipie",
        "cipą",
        "cip",
        "cipka",
        "c*pa"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar female anatomy term, regional variant of pizda but less severe",
      "target_type": "female",
      "regions": [
        "southern"
      ],
      "compound_potential": "Low - regional usage"
    },
    {
      "word": "cipka",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Female Genitalia",
      "target_type": "female",
      "regions": [
        "all"
      ]
    },
    {
      "word": "cipsko",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Female Genitalia",
      "target_type": "female",
      "regions": [
        "all"
      ]
    },
    {
      "word": "cipunia",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Female Genitalia",
      "target_type": "female",
      "regions": [
        "all"
      ]
    },
    {
      "word": "cwel",
      "severity": 3,
      "categories": [
        "derogatory",
        "homophobic",
        "insult"
      ],
      "variations": [
        "cwela",
        "cwelowi",
        "cwelem",
        "cwele",
        "cweli",
        "cwelów",
        "cw*l"
      ],
      "case_sensitive": false,
      "context_notes": "Faggot/weakling - homophobic slur, also used for weak person",
      "target_type": "male",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - derogatory slur"
    },
    {
      "word": "cycki",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Breasts",
      "target_type": "female",
      "regions": [
        "all"
      ]
    },
    {
      "word": "cycuszki",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Breasts",
      "target_type": "female",
      "regions": [
        "all"
      ]
    },
    {
      "word": "cygan",
      "severity": 1,
      "categories": [
        "ethnic",
        "hate_speech",
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Ethnic Slurs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "debil",
      "severity": 2,
      "categories": [
        "derogatory",
        "insult",
        "ableist"
      ],
      "variations": [
        "debila",
        "debilowi",
        "debilem",
        "debile",
        "debili",
        "debilów",
        "debilom",
        "debilami",
        "debilny",
        "d*bil"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot/moron - ableist slur, moderate severity",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - mainly insult usage"
    },
    {
      "word": "debilka",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Intelligence Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "diabel",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Mild Terms",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "diabeł",
      "severity": 1,
      "categories": [
        "religious",
        "mild_profanity"
      ],
      "variations": [
        "diabła",
        "diabłu",
        "diabłem",
        "diabłami",
        "diabłach",
        "diabli",
        "diabłów",
        "do diabła"
      ],
      "case_sensitive": false,
      "context_notes": "Devil - mild religious profanity, used in exclamations",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - mainly religious context"
    },
    {
      "word": "diabli",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Mild Terms",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "dojebać",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "dosrać",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Scatological Feces",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "dowjebać",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "dupa",
      "severity": 2,
      "categories": [
        "anatomy",
        "profanity"
      ],
      "variations": [
        "dupę",
        "dupy",
        "dupie",
        "dupą",
        "dup",
        "dupcia",
        "dupsko",
        "dupek",
        "d*pa"
      ],
      "case_sensitive": false,
      "context_notes": "Buttocks/ass - moderate vulgarity, sometimes used affectionately",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - dupowaty, dupowóz"
    },
    {
      "word": "dupcia",
      "severity": 2,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Buttocks/Anus",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "dupczyć",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Copulation Verbs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "dupek",
      "severity": 2,
      "categories": [
        "insult",
        "profanity"
      ],
      "variations": [
        "dupka",
        "dupkowi",
        "dupkiem",
        "dupki",
        "dupków",
        "dupkom",
        "dupkami",
        "dup*k"
      ],
      "case_sensitive": false,
      "context_notes": "Asshole - moderate insult, diminutive of dupa",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - diminutive form"
    },
    {
      "word": "dupka",
      "severity": 2,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Buttocks/Anus",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "dupsko",
      "severity": 2,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Buttocks/Anus",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "dzban",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "dziwka",
      "severity": 3,
      "categories": [
        "sexual",
        "derogatory",
        "gendered"
      ],
      "variations": [
        "dziwkę",
        "dziwki",
        "dziwce",
        "dziwką",
        "dziwek",
        "dziw*a"
      ],
      "case_sensitive": false,
      "context_notes": "Whore/slut - derogatory term for women, sexually charged insult",
      "target_type": "female",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - gendered insult"
    },
    {
      "word": "dziwki",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Prostitution",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "fiut",
      "severity": 2,
      "categories": [
        "sexual",
        "anatomy",
        "regional"
      ],
      "variations": [
        "fiuta",
        "fiutowi",
        "fiutem",
        "fiuty",
        "fiutów",
        "fiutom",
        "fi*t"
      ],
      "case_sensitive": false,
      "context_notes": "Penis - regional vulgar term, less severe than chuj",
      "target_type": "male",
      "regions": [
        "northern"
      ],
      "compound_potential": "Low - regional variant"
    },
    {
      "word": "głąb",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Intelligence Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "głupek",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Intelligence Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "gnida",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "gnój",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "gówniany",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Scatological Feces",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "gówniara",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Scatological Feces",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "gówniarz",
      "severity": 2,
      "categories": [
        "derogatory",
        "age",
        "insult"
      ],
      "variations": [
        "gówniarza",
        "gówniarzowi",
        "gówniarzem",
        "gówniarze",
        "gówniarzy",
        "gówniarzom",
        "g*wniarz"
      ],
      "case_sensitive": false,
      "context_notes": "Little shit/brat - moderate insult for young person acting badly",
      "target_type": "young",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - age-based insult"
    },
    {
      "word": "gówno",
      "severity": 2,
      "categories": [
        "scatological",
        "profanity"
      ],
      "variations": [
        "gówna",
        "gównami",
        "gównach",
        "gównie",
        "gównem",
        "gówniak",
        "gówniarz",
        "g*wno",
        "gowno"
      ],
      "case_sensitive": false,
      "context_notes": "Shit - moderate profanity, used to describe something worthless or bad",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "High - gównojad, gównowóz"
    },
    {
      "word": "homoszczur",
      "severity": 4,
      "categories": [
        "homophobic",
        "hate_speech",
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Homosexual Slurs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "huj",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Male Genitalia",
      "target_type": "male",
      "regions": [
        "all"
      ]
    },
    {
      "word": "idiota",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Intelligence Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "jaja",
      "severity": 2,
      "categories": [
        "sexual",
        "anatomy",
        "slang"
      ],
      "variations": [
        "jaj",
        "jajami",
        "jajach",
        "jajko",
        "jajka",
        "j*ja"
      ],
      "case_sensitive": false,
      "context_notes": "Balls/testicles - moderate vulgar slang for male anatomy",
      "target_type": "male",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - anatomical slang"
    },
    {
      "word": "jasna cholera",
      "severity": 1,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Religious",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "jebac",
      "severity": 3,
      "categories": [
        "sexual",
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Copulation Verbs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "jebać",
      "severity": 3,
      "categories": [
        "profanity",
        "sexual",
        "verb"
      ],
      "variations": [
        "jebię",
        "jebiesz",
        "jebie",
        "jebiemy",
        "jebiecie",
        "jebią",
        "jebał",
        "jebała",
        "jebane",
        "jebaną",
        "jebaniec",
        "najebać",
        "zajebać",
        "wyjebać",
        "przejebać",
        "pojebać"
      ],
      "case_sensitive": false,
      "context_notes": "Secondary vulgar verb - fuck. Like pierdolić, takes many prefixes with different meanings",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Extremely high - extensive prefixed variations"
    },
    {
      "word": "jebaniec",
      "severity": 3,
      "categories": [
        "profanity",
        "derogatory",
        "insult"
      ],
      "variations": [
        "jebańca",
        "jebańcowi",
        "jebańcem",
        "jebańce",
        "jebańców",
        "jeb*niec"
      ],
      "case_sensitive": false,
      "context_notes": "Fucker/asshole - strong personal insult derived from jebać",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - personal insult"
    },
    {
      "word": "jebany",
      "severity": 3,
      "categories": [
        "profanity",
        "adjective",
        "intensifier"
      ],
      "variations": [
        "jebana",
        "jebane",
        "jebanych",
        "jebanym",
        "jebanej",
        "jebanymi",
        "jeb*ny"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking/damn - intensifying adjective from jebać, very strong emphasis",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - intensifier usage"
    },
    {
      "word": "jebnąć",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "jebnięty",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "kłamca",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "kozojeb",
      "severity": 4,
      "categories": [
        "derogatory",
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Animal Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "kretyn",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Intelligence Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "kretynka",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Intelligence Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "kurewnik",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Prostitution",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "kurewska",
      "severity": 3,
      "categories": [
        "profanity",
        "adjective",
        "gendered"
      ],
      "variations": [
        "kurewskiej",
        "kurewską",
        "kurewskie",
        "kurewskich",
        "kurewskim",
        "kur*wska"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking/bitchy - feminine form of kurewski, intensifying adjective",
      "target_type": "female",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - gendered intensifier"
    },
    {
      "word": "kurewski",
      "severity": 3,
      "categories": [
        "profanity",
        "adjective",
        "intensifier"
      ],
      "variations": [
        "kurewska",
        "kurewskie",
        "kurewskich",
        "kurewskim",
        "kurewskiej",
        "kurewskimi"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking/damn - intensifying adjective derived from kurwa",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - intensifier usage"
    },
    {
      "word": "kurewsko",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Prostitution",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "kurwa",
      "severity": 3,
      "categories": [
        "general",
        "profanity",
        "sexual"
      ],
      "variations": [
        "kurwą",
        "kurwy",
        "kurwie",
        "kurwę",
        "kurw",
        "kurewka",
        "kurwiak",
        "kurwiszon",
        "kurv@",
        "k*rwa",
        "k***a"
      ],
      "case_sensitive": false,
      "context_notes": "Most versatile Polish profanity - whore/fuck/shit, used as exclamation, comma in speech, or harsh insult",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Extremely high - kurwa mać, kurwa jego mać, etc."
    },
    {
      "word": "kurwiszon",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Prostitution",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "kurwy",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Prostitution",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "kutas",
      "severity": 3,
      "categories": [
        "sexual",
        "anatomy",
        "profanity"
      ],
      "variations": [
        "kutasa",
        "kutasowi",
        "kutasem",
        "kutasy",
        "kutasów",
        "kutasom",
        "kutasami",
        "k*tas"
      ],
      "case_sensitive": false,
      "context_notes": "Vulgar term for penis, alternative to chuj",
      "target_type": "male",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - mainly standalone usage"
    },
    {
      "word": "licho",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Mild Terms",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "mać",
      "severity": 1,
      "categories": [
        "mild_profanity",
        "exclamation"
      ],
      "variations": [
        "kurwa mać",
        "jezus mać",
        "m*ć"
      ],
      "case_sensitive": false,
      "context_notes": "Mild exclamation - usually combined with other words, from 'mother'",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "High - combination word"
    },
    {
      "word": "maciupię",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Mother Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "matkojebca",
      "severity": 4,
      "categories": [
        "derogatory",
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Mother Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "murzyn",
      "severity": 1,
      "categories": [
        "ethnic",
        "hate_speech",
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Ethnic Slurs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "najebać",
      "severity": 3,
      "categories": [
        "profanity",
        "verb",
        "prefixed"
      ],
      "variations": [
        "najebię",
        "najebiesz",
        "najebie",
        "najebiemy",
        "najebiecie",
        "najebią",
        "najebał",
        "najebała",
        "najebane"
      ],
      "case_sensitive": false,
      "context_notes": "To get drunk/beat up - prefixed jebać with multiple meanings depending on context",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - specific prefixed meaning"
    },
    {
      "word": "najebany",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "napierdalać",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "napierdolić",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "naszczać",
      "severity": 1,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Scatological Urine",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "nawjebać",
      "severity": 3,
      "categories": [
        "profanity",
        "verb",
        "quantity"
      ],
      "variations": [
        "nawjebało",
        "nawjebane",
        "nawjebany",
        "nawjebana",
        "nawjeb*ć"
      ],
      "case_sensitive": false,
      "context_notes": "Shitload/lots of - prefixed jebać meaning large quantity of something",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - quantity expression"
    },
    {
      "word": "niedorozwój",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Intelligence Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "obesraniec",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Scatological Feces",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "ochujać",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of chuj",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "odjebać",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "odjebany",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "odpierdalać",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "odpierdolić",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "opierdalać",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "opierdolić",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "osrać",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Scatological Feces",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "oszust",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "pała",
      "severity": 2,
      "categories": [
        "sexual",
        "anatomy",
        "slang"
      ],
      "variations": [
        "pałę",
        "pały",
        "pale",
        "pałą",
        "pał",
        "p*ła"
      ],
      "case_sensitive": false,
      "context_notes": "Dick/penis - slang term, moderate vulgarity",
      "target_type": "male",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - slang variant"
    },
    {
      "word": "parszywa",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "pedał",
      "severity": 3,
      "categories": [
        "homophobic",
        "derogatory",
        "slur"
      ],
      "variations": [
        "pedała",
        "pedałowi",
        "pedałem",
        "pedały",
        "pedałów",
        "pedałom",
        "ped*ł"
      ],
      "case_sensitive": false,
      "context_notes": "Faggot - homophobic slur, highly offensive to LGBTQ+ individuals",
      "target_type": "male",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - hate speech"
    },
    {
      "word": "pedały",
      "severity": 1,
      "categories": [
        "homophobic",
        "hate_speech",
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Homosexual Slurs",
      "target_type": "male",
      "regions": [
        "all"
      ]
    },
    {
      "word": "pedryl",
      "severity": 3,
      "categories": [
        "homophobic",
        "hate_speech",
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Homosexual Slurs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "piekło",
      "severity": 1,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Religious",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "pieprzyć",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Copulation Verbs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "pierdoła",
      "severity": 2,
      "categories": [
        "profanity",
        "derogatory",
        "diminutive"
      ],
      "variations": [
        "pierdołę",
        "pierdoły",
        "pierdole",
        "pierdołą",
        "pierdół",
        "pierd*ła"
      ],
      "case_sensitive": false,
      "context_notes": "Moron/idiot - mild insult derived from pierdolić, diminutive form",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - diminutive insult"
    },
    {
      "word": "pierdolenie",
      "severity": 2,
      "categories": [
        "profanity",
        "noun",
        "nonsense"
      ],
      "variations": [
        "pierdolenia",
        "pierdoleniu",
        "pierdoleniem",
        "pierdul*nie"
      ],
      "case_sensitive": false,
      "context_notes": "Bullshit/nonsense talk - noun from pierdolić meaning meaningless chatter",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - descriptive noun"
    },
    {
      "word": "pierdolić",
      "severity": 3,
      "categories": [
        "profanity",
        "sexual",
        "verb"
      ],
      "variations": [
        "pierdolę",
        "pierdolisz",
        "pierdoli",
        "pierdolimy",
        "pierdolicie",
        "pierdolą",
        "pierdolił",
        "pierdoliła",
        "pierdolone",
        "pierdoląc",
        "napierdalać",
        "spierdalać",
        "wypierdalać",
        "zapierdalać",
        "pierdol się",
        "spierdalaj"
      ],
      "case_sensitive": false,
      "context_notes": "Primary vulgar verb - fuck/screw. Extremely versatile with prefixes changing meaning dramatically",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Extremely high - dozens of prefixed forms"
    },
    {
      "word": "pierdolnąć",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "pierdolnięty",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "pierdolnik",
      "severity": 2,
      "categories": [
        "profanity",
        "slang",
        "object"
      ],
      "variations": [
        "pierdolnika",
        "pierdolnikowi",
        "pierdolnikiem",
        "pierdolniki",
        "pierdolników",
        "pierdol*ik"
      ],
      "case_sensitive": false,
      "context_notes": "Piece of junk - slang for broken or useless object",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - object description"
    },
    {
      "word": "pierdolony",
      "severity": 3,
      "categories": [
        "profanity",
        "adjective",
        "intensifier"
      ],
      "variations": [
        "pierdolona",
        "pierdolone",
        "pierdolonych",
        "pierdolonym",
        "pierdolonej",
        "pierdolonymi",
        "pierdol*ny"
      ],
      "case_sensitive": false,
      "context_notes": "Fucking/damn - intensifying adjective from pierdolić, emphasis and anger",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - intensifier usage"
    },
    {
      "word": "pierdzieć",
      "severity": 1,
      "categories": [
        "scatological",
        "verb",
        "mild_profanity"
      ],
      "variations": [
        "pierdzę",
        "pierdzisz",
        "pierdzi",
        "pierdzimy",
        "pierdzicie",
        "pierdzą",
        "pierdział",
        "pierdziała",
        "pierdnąć",
        "pierdnięcie"
      ],
      "case_sensitive": false,
      "context_notes": "To fart - mild scatological term, often humorous",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - mainly scatological context"
    },
    {
      "word": "pies",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Animal Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "pindol",
      "severity": 2,
      "categories": [
        "sexual",
        "anatomy",
        "slang"
      ],
      "variations": [
        "pindola",
        "pindolowi",
        "pindolem",
        "pindole",
        "pindoli",
        "p*ndol"
      ],
      "case_sensitive": false,
      "context_notes": "Penis - regional slang variant, moderate vulgarity",
      "target_type": "male",
      "regions": [
        "regional"
      ],
      "compound_potential": "Low - regional slang"
    },
    {
      "word": "pizda",
      "severity": 4,
      "categories": [
        "sexual",
        "profanity",
        "anatomy",
        "derogatory"
      ],
      "variations": [
        "pizdę",
        "pizdy",
        "pizdzie",
        "pizdą",
        "pizd",
        "pizdeczka",
        "p*zda"
      ],
      "case_sensitive": false,
      "context_notes": "Extremely vulgar female anatomy term (cunt) - highest severity offensive term",
      "target_type": "female",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - pizdowaty"
    },
    {
      "word": "pizdnąć",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pizda",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "piździć",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pizda",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "plugawy",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "podjebać",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "podpierdalać",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "pojeb",
      "severity": 3,
      "categories": [
        "derogatory",
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Intelligence Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "pojebać",
      "severity": 3,
      "categories": [
        "profanity",
        "verb",
        "mental"
      ],
      "variations": [
        "pojebało",
        "pojebane",
        "pojebany",
        "pojebana",
        "pojebanej",
        "pojeb*ć"
      ],
      "case_sensitive": false,
      "context_notes": "To go crazy/be fucked up - prefixed jebać referring to mental state",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - mental state description"
    },
    {
      "word": "pojebało",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "pojebany",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "popierdoleniec",
      "severity": 3,
      "categories": [
        "derogatory",
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Intelligence Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "popierdolić",
      "severity": 3,
      "categories": [
        "profanity",
        "verb",
        "prefixed"
      ],
      "variations": [
        "popierdelę",
        "popierdelisz",
        "popierdeli",
        "popierdelimy",
        "popierdelicie",
        "popierdelą",
        "popierdelił",
        "popierdeliła"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck up/mess up - prefixed form of pierdolić meaning to ruin something",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - specific prefixed meaning"
    },
    {
      "word": "popierdolony",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "popierdzielec",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Intelligence Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "posrać",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Scatological Feces",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "poszczać",
      "severity": 2,
      "categories": [
        "scatological",
        "verb",
        "profanity"
      ],
      "variations": [
        "poszczę",
        "poszczasz",
        "poszcza",
        "poszczamy",
        "poszczacie",
        "poszczą",
        "poszczał",
        "poszczała",
        "poszcz*ć"
      ],
      "case_sensitive": false,
      "context_notes": "To piss on - scatological verb meaning to urinate on something",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - scatological usage"
    },
    {
      "word": "przejebane",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "przepierdolić",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "przesrać",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Scatological Feces",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "przesrane",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Scatological Feces",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "przygłup",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Intelligence Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "przypierdolić",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "psiakość",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Mild Terms",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "psiakrew",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Mild Terms",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "rozjebać",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "rozpierdalać",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "rozpiździć",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pizda",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "ruchać",
      "severity": 3,
      "categories": [
        "sexual",
        "verb",
        "profanity"
      ],
      "variations": [
        "rucham",
        "ruchasz",
        "rucha",
        "ruchamy",
        "ruchacie",
        "ruchają",
        "ruchał",
        "ruchała",
        "ruruchanie",
        "r*chać"
      ],
      "case_sensitive": false,
      "context_notes": "To fuck - vulgar sexual verb, primary meaning sexual intercourse",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - sexual context"
    },
    {
      "word": "rżnąć",
      "severity": 3,
      "categories": [
        "sexual",
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Copulation Verbs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "skurczygnat",
      "severity": 1,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Religious",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "skurwiel",
      "severity": 4,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Prostitution",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "skurwysyn",
      "severity": 4,
      "categories": [
        "profanity",
        "derogatory",
        "compound"
      ],
      "variations": [
        "skurwysyna",
        "skurwysynowi",
        "skurwysynem",
        "skurwysyny",
        "skurwysynów",
        "skurwysynom",
        "skurwysynami",
        "sk*rwysyn"
      ],
      "case_sensitive": false,
      "context_notes": "Son of a whore - extremely offensive compound insult combining kurwa + syn",
      "target_type": "male",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - already compound"
    },
    {
      "word": "skurwysyna",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Prostitution",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "śmieć",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "spierdalaj",
      "severity": 4,
      "categories": [
        "profanity",
        "imperative",
        "dismissive"
      ],
      "variations": [
        "spierdalam",
        "spierdalasz",
        "spierdala",
        "spierdalamy",
        "spierdalajcie",
        "spierdalają",
        "spierdol się",
        "sp*erdalaj"
      ],
      "case_sensitive": false,
      "context_notes": "Fuck off/get lost - extremely strong dismissive command, reserved for heated arguments",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - mainly imperative usage"
    },
    {
      "word": "spierdolić",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "spierdolina",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "spizdzić",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pizda",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "srać",
      "severity": 2,
      "categories": [
        "scatological",
        "verb",
        "profanity"
      ],
      "variations": [
        "srę",
        "srasz",
        "sra",
        "sramy",
        "sracie",
        "srają",
        "srał",
        "srała",
        "nasrać",
        "posrać"
      ],
      "case_sensitive": false,
      "context_notes": "To shit/defecate - moderate scatological profanity",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - prefixed forms"
    },
    {
      "word": "sranie",
      "severity": 2,
      "categories": [
        "scatological",
        "profanity",
        "noun"
      ],
      "variations": [
        "srania",
        "sraniu",
        "sraniem",
        "srań",
        "sr*nie"
      ],
      "case_sensitive": false,
      "context_notes": "Shitting/crap - scatological noun, moderate profanity for bad situation",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - scatological usage"
    },
    {
      "word": "suka",
      "severity": 2,
      "categories": [
        "derogatory",
        "gendered",
        "animal"
      ],
      "variations": [
        "sukę",
        "suki",
        "suce",
        "suką",
        "suk",
        "s*ka"
      ],
      "case_sensitive": false,
      "context_notes": "Bitch - derogatory term for women, borrowed from animal terminology",
      "target_type": "female",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - gendered insult"
    },
    {
      "word": "sukinkot",
      "severity": 1,
      "categories": [
        "religious"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Religious",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "sukinsyn",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Mother Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "sukinsynu",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Mother Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "świnia",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "świństwo",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Appearance Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "szczać",
      "severity": 2,
      "categories": [
        "scatological",
        "verb",
        "profanity"
      ],
      "variations": [
        "szczę",
        "szczasz",
        "szcza",
        "szczamy",
        "szczacie",
        "szczają",
        "szczał",
        "szczała",
        "naszczać",
        "poszczać"
      ],
      "case_sensitive": false,
      "context_notes": "To piss/urinate - moderate scatological profanity",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - prefixed forms"
    },
    {
      "word": "szczanie",
      "severity": 2,
      "categories": [
        "scatological",
        "profanity",
        "noun"
      ],
      "variations": [
        "szczania",
        "szczaniu",
        "szczaniem",
        "szczań",
        "szcz*nie"
      ],
      "case_sensitive": false,
      "context_notes": "Pissing - scatological noun from szczać, moderate vulgarity",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - scatological usage"
    },
    {
      "word": "szmata",
      "severity": 2,
      "categories": [
        "derogatory",
        "gendered",
        "insult"
      ],
      "variations": [
        "szmatę",
        "szmaty",
        "szmacie",
        "szmatą",
        "szmat",
        "szm*ta"
      ],
      "case_sensitive": false,
      "context_notes": "Rag/slut - derogatory term for women, implies worthlessness",
      "target_type": "female",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - gendered insult"
    },
    {
      "word": "tuman",
      "severity": 1,
      "categories": [
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Intelligence Insults",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "tyłek",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Buttocks/Anus",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "ujebać",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "upierdolić",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "walić",
      "severity": 3,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Copulation Verbs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "wjebać",
      "severity": 3,
      "categories": [
        "profanity",
        "verb",
        "violence"
      ],
      "variations": [
        "wjebię",
        "wjebiesz",
        "wjebie",
        "wjebiemy",
        "wjebiecie",
        "wjebią",
        "wjebał",
        "wjebała"
      ],
      "case_sensitive": false,
      "context_notes": "To hit hard/crash into - violent prefixed form of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - violent context"
    },
    {
      "word": "wkurwiać",
      "severity": 2,
      "categories": [
        "profanity",
        "verb",
        "emotion"
      ],
      "variations": [
        "wkurwiam",
        "wkurwiasz",
        "wkurwia",
        "wkurwiamy",
        "wkurzać",
        "wkurwiony",
        "wkurwiona"
      ],
      "case_sensitive": false,
      "context_notes": "To piss off/annoy - derived from kurwa, means to anger or irritate",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Medium - emotional states"
    },
    {
      "word": "wkurwić",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Prostitution",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "wpierdalać",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "wpierdol",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "wychujać",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of chuj",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "wyjebać",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "wyjebany",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "wykurwisty",
      "severity": 1,
      "categories": [
        "sexual"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Prostitution",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "wypierdalać",
      "severity": 3,
      "categories": [
        "profanity",
        "verb",
        "dismissive"
      ],
      "variations": [
        "wypierdalam",
        "wypierdalasz",
        "wypierdala",
        "wypierdalamy",
        "wypierdalajcie",
        "wypierdalaj",
        "wypierdolić"
      ],
      "case_sensitive": false,
      "context_notes": "Get the fuck out - strong dismissive command, prefixed pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - dismissive command"
    },
    {
      "word": "wypierdalaj",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "wypierdek",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pierdolić",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "wypizd",
      "severity": 1,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of pizda",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "wyruchać",
      "severity": 3,
      "categories": [
        "sexual",
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Copulation Verbs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "wysrać",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Scatological Feces",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "zachujać",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of chuj",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "zajebać",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "zajebiste",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "zajebisty",
      "severity": 2,
      "categories": [
        "profanity",
        "positive",
        "slang"
      ],
      "variations": [
        "zajebista",
        "zajebiste",
        "zajebistych",
        "zajebistym",
        "zajebistymi",
        "zajebistej",
        "zajeb*sty"
      ],
      "case_sensitive": false,
      "context_notes": "Awesome/fucking great - paradoxically positive despite vulgar origin",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - positive slang"
    },
    {
      "word": "zasrać",
      "severity": 2,
      "categories": [
        "scatological",
        "verb",
        "profanity"
      ],
      "variations": [
        "zasram",
        "zasrasz",
        "zasra",
        "zasramy",
        "zasracie",
        "zasrają",
        "zasrał",
        "zasrała",
        "zasr*ć"
      ],
      "case_sensitive": false,
      "context_notes": "To shit all over - scatological verb meaning to soil or mess up badly",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - scatological usage"
    },
    {
      "word": "zasraniec",
      "severity": 3,
      "categories": [
        "scatological",
        "derogatory",
        "insult"
      ],
      "variations": [
        "zasrańca",
        "zasrańcowi",
        "zasrańcem",
        "zasrańce",
        "zasrańców",
        "zasr*niec"
      ],
      "case_sensitive": false,
      "context_notes": "Piece of shit person - strong insult combining scatological with personal attack",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - personal insult"
    },
    {
      "word": "zasrany",
      "severity": 2,
      "categories": [
        "scatological"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Scatological Feces",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "zjeb",
      "severity": 3,
      "categories": [
        "profanity",
        "derogatory",
        "insult"
      ],
      "variations": [
        "zjeba",
        "zjebowi",
        "zjebem",
        "zjeby",
        "zjebów",
        "zjebom",
        "zjebami",
        "zjebane",
        "zj*b"
      ],
      "case_sensitive": false,
      "context_notes": "Idiot/moron - harsh personal insult derived from jebać",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - primarily insult usage"
    },
    {
      "word": "zjebać",
      "severity": 3,
      "categories": [
        "profanity"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Derivatives of jebać",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "zjebany",
      "severity": 3,
      "categories": [
        "profanity",
        "adjective",
        "condition"
      ],
      "variations": [
        "zjebana",
        "zjebane",
        "zjebanych",
        "zjebanym",
        "zjebanej",
        "zjebanymi",
        "zjeb*ny"
      ],
      "case_sensitive": false,
      "context_notes": "Fucked up/broken - adjective describing damaged or problematic state",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - condition description"
    },
    {
      "word": "żul",
      "severity": 2,
      "categories": [
        "derogatory",
        "classist",
        "homeless"
      ],
      "variations": [
        "żula",
        "żulowi",
        "żulem",
        "żule",
        "żuli",
        "żulów",
        "ż*l"
      ],
      "case_sensitive": false,
      "context_notes": "Bum/homeless person - derogatory term for vagrant or alcoholic",
      "target_type": "general",
      "regions": [
        "all"
      ],
      "compound_potential": "Low - classist slur"
    },
    {
      "word": "żyd",
      "severity": 1,
      "categories": [
        "ethnic",
        "hate_speech",
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Ethnic Slurs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    },
    {
      "word": "żydzi",
      "severity": 1,
      "categories": [
        "ethnic",
        "hate_speech",
        "derogatory"
      ],
      "variations": [],
      "case_sensitive": false,
      "context_notes": "Polish profanity - from Ethnic Slurs",
      "target_type": "general",
      "regions": [
        "all"
      ]
    }
  ]
} as const

export type PLType = typeof PL
